import { classifyRedirectUrl, isValidHttpUrl } from "@/libs/safetyLookup";

export default {
    data() {
        return {
            redirectSafetyTimer: null,
            redirectSafetyResult: null,
            redirectSafetyError: "",
            redirectSafetyPending: false,
            redirectSafetyCheckedUrl: "",
        };
    },
    computed: {
        redirectUrlIsValid() {
            return isValidHttpUrl(this.redirecturl);
        },
        redirectSafetyBlocked() {
            return this.redirectSafetyResult?.verdict === "blocked";
        },
        redirectSafetyChecked() {
            return Boolean(this.redirectSafetyResult && this.redirectSafetyCheckedUrl === this.redirecturl);
        },
        redirectSafetyTooltip() {
            if (!this.redirectSafetyResult) return "";
            return JSON.stringify(this.redirectSafetyResult, null, 2);
        },
        redirectSafetyState() {
            if (!this.redirecturl) {
                return {
                    visible: false,
                    label: "",
                    className: "",
                };
            }
            if (!this.redirectUrlIsValid) {
                return {
                    visible: true,
                    label: "Enter a valid URL",
                    className: "isPending",
                };
            }
            if (this.redirectSafetyPending) {
                return {
                    visible: true,
                    label: "Checking...",
                    className: "isPending",
                };
            }
            if (this.redirectSafetyChecked) {
                return {
                    visible: true,
                    label: this.redirectSafetyBlocked ? "Blocked" : "OK",
                    className: this.redirectSafetyBlocked ? "isBlocked" : "isOk",
                };
            }
            if (this.redirectSafetyError) {
                return {
                    visible: true,
                    label: "Check failed",
                    className: "isBlocked",
                };
            }
            return {
                visible: true,
                label: "Waiting to check...",
                className: "isPending",
            };
        },
        redirectSafetyCanSubmit() {
            return (
                this.redirectUrlIsValid &&
                this.redirectSafetyChecked &&
                !this.redirectSafetyBlocked &&
                !this.redirectSafetyPending
            );
        },
    },
    watch: {
        redirecturl() {
            this.scheduleRedirectSafetyCheck();
        },
    },
    methods: {
        clearRedirectSafetyTimer() {
            if (this.redirectSafetyTimer) {
                clearTimeout(this.redirectSafetyTimer);
                this.redirectSafetyTimer = null;
            }
        },
        resetRedirectSafetyState() {
            this.redirectSafetyResult = null;
            this.redirectSafetyError = "";
            this.redirectSafetyPending = false;
            this.redirectSafetyCheckedUrl = "";
        },
        scheduleRedirectSafetyCheck() {
            this.clearRedirectSafetyTimer();
            this.redirectSafetyError = "";
            this.redirectSafetyResult = null;
            this.redirectSafetyCheckedUrl = "";

            if (!this.redirecturl || !this.redirectUrlIsValid) {
                this.redirectSafetyPending = false;
                return;
            }

            this.redirectSafetyPending = true;
            this.redirectSafetyTimer = setTimeout(() => {
                this.runRedirectSafetyCheck();
            }, 2000);
        },
        async runRedirectSafetyCheck() {
            const urlToCheck = this.redirecturl;
            if (!this.redirectUrlIsValid || !urlToCheck) {
                this.redirectSafetyPending = false;
                return;
            }

            try {
                const result = await classifyRedirectUrl(urlToCheck);
                if (this.redirecturl !== urlToCheck) return;
                this.redirectSafetyResult = result;
                this.redirectSafetyCheckedUrl = urlToCheck;
                this.redirectSafetyError = "";
            } catch (err) {
                if (this.redirecturl !== urlToCheck) return;
                this.redirectSafetyResult = null;
                this.redirectSafetyCheckedUrl = "";
                this.redirectSafetyError = err?.message || "Safety lookup failed";
            } finally {
                if (this.redirecturl === urlToCheck) {
                    this.redirectSafetyPending = false;
                }
                this.redirectSafetyTimer = null;
            }
        },
    },
    beforeUnmount() {
        this.clearRedirectSafetyTimer();
    },
};
